import AccordionHtml from './rfct/html/accordion-html';
import LinkListHtml from './rfct/html/link-list-html';
import moduleRegistry from './rfct/module-registry/module-registry';

// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $globalConfig = config;
}

const categoryConfig = {
    selectors: {
        resultList: '.catalog__cards-category',
        lightbox: '.single-lightbox',
    },
};

function init() {
    $(categoryConfig.selectors.resultList).each((i, el) => {
        const $searchResultList = $(el);
        initCategory($searchResultList);
        if ($(categoryConfig.selectors.lightbox).length > 0) {
            initLightbox(jQuery(categoryConfig.selectors.lightbox));
        }
    });
}

// init logic
function initLightbox($lightbox) {
    $lightbox.imageLightbox({
        button: true,
        overlay: true,
        animationSpeed: 250,
        quitOnImgClick: true,
        caption: true,
    });

    // initializeLightboxes();
}

function initCategory($searchResultList) {
    const categoryDescription = $searchResultList.attr('data-description') || false;
    const breadcrumb = jQuery('#dinamic-category-breadcrumb-content');
    const dataIds = breadcrumb.attr('data-nav-id') || '';
    const dataIdsList = dataIds !== '' ? dataIds.split('#') : [];
    const $catalogID = dataIdsList[2] || '';

    const url = new URL(window.location.href);
    const $categoryID = !isNaN(url.searchParams.get('cat')) ? url.searchParams.get('cat') : '';
    let $categoryType = '';
    const apiURL = `${$globalConfig.urls.getRecursiveCategories}?category=${$categoryID}`;
    jQuery.ajax({
        type: 'GET',
        url: apiURL,
        processData: false,
        dataType: 'json',
        success(data) {
            const childs = [];
            $categoryType = data.type;

            data.children.forEach((category) => {
                const categoryURL = category.hasChildren ? `${$globalConfig.urls.categoryHtml}?cat=${category.identifier}`
                    : `${$globalConfig.urls.searchHtml}?cat=${category.identifier}`;

                childs.push({ title: category.name, link: categoryURL });

                new LinkListHtml(childs).toString();
                // eslint-disable-next-line max-len
            });

            const contentHtml = new LinkListHtml(childs).toString();
            const html = `
                    <div class="${categoryDescription ? 'col-lg-6' : 'col-lg-7 offset-lg-2'}">
                        <div class="rfct-color-box">
                            <div class="rfct-textblock">
                                <h3 class="rfct-color-box__headline mb-4">${$globalConfig.textResources.productCatalogConnectorConfig.labelCategorySubCategories}</h3>
                            </div>
                            ${contentHtml}
                        </div>
                    </div>
            `;

            const apiURL2 = `${$globalConfig.urls.getRecursiveCategories}?category=${$catalogID}`;
            jQuery.ajax({
                type: 'GET',
                url: apiURL2,
                processData: false,
                dataType: 'json',
                success(data2) {
                    const indicationAccordionItems = [];
                    let headline = '';
                    data2.children.forEach((mainCategory) => {
                        if (mainCategory.type === $categoryType && mainCategory.hasChildren) {
                            const nameArray = mainCategory.position.split('#');
                            headline = nameArray[nameArray.length - 2];
                            mainCategory.children.forEach((child) => {
                                const childs2 = [];
                                // eslint-disable-next-line max-len
                                const baseUrl = child.hasChildren ? $globalConfig.urls.categoryHtml : $globalConfig.urls.searchHtml;
                                child.children.forEach((subChild) => {
                                    // eslint-disable-next-line max-len
                                    const childBaseUrl = subChild.hasChildren ? $globalConfig.urls.categoryHtml : $globalConfig.urls.searchHtml;
                                    const indicationUrl = `${childBaseUrl}?cat=${subChild.identifier}`;
                                    childs2.push({ title: subChild.name, link: indicationUrl });
                                });
                                childs2.push({ title: $globalConfig.textResources.productCatalogConnectorConfig.categoryPageLinkText, link: `${baseUrl}?cat=${child.identifier}` });
                                const childHtml = new LinkListHtml(childs2).toString();
                                // eslint-disable-next-line max-len
                                indicationAccordionItems.push({ title: child.name, content: childHtml });
                            });
                        }
                    });
                    const multiple = true;
                    // eslint-disable-next-line max-len
                    const contentHtml2 = new AccordionHtml(indicationAccordionItems, multiple).toString();
                    const html2 = `
                            <div class="${categoryDescription ? 'col-lg-6' : 'col-lg-7 offset-lg-2'}">
                                <h3 class="h3">${$globalConfig.textResources.productCatalogConnectorConfig.labelCategoryRelatedIndications} ${headline}</h3>
                                ${contentHtml2}
                            </div>
                    `;
                    const options = {
                        append: true,
                    };
                    moduleRegistry.insertHTML($searchResultList, html + html2, options);
                },
                error() {
                    // eslint-disable-next-line no-console
                    // console.log('Error loading catalog result!');
                },
            });
        },
        error() {
            // eslint-disable-next-line no-console
            // console.log('Error loading category result!');
        },
    });
}

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    init();
}
